import React from 'react';
import SubscriberList from '../components/Subscribers/SubscriberList';

const SubscriberPage = () => {
  return (
    <div>
      <h1>Gestion des Abonnés</h1>
      <SubscriberList />
    </div>
  );
};

export default SubscriberPage;
